module.exports = __webpack_public_path__ + "static/media/difficulty3.9890a384.png";